import apiRequest from "../../helpers/apiRequest";

export default async (obj) => {
    return await apiRequest({
        method: 'post',
        url: `accounts/tutor/holiday`,
        data: obj
    })
}
